import { Router } from '@angular/router';
import {Component, HostListener, OnInit} from '@angular/core';
import { AuthenticationService } from "app/service/authentication.service";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  isCodeFlow: boolean;
  code: string;
  scrHeight: any;
  scrWidth: any;
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;
    if (this.scrWidth < 995 ) {
      document.getElementById('nav-div').className = 'navigasyon-div-responsive ';
      document.getElementById('system-div').className = 'navigasyon-div-responsive ';
      document.getElementById('logo-div').className = 'footer-logo-div-responsive';
      document.getElementById('sosial-div').className = 'sosyal-medya-div-responsive';
      document.getElementById('site-footer').className = 'footer-responsive';
    } else {
      document.getElementById('nav-div').className = 'navigasyon-div';
      document.getElementById('system-div').className = 'navigasyon-div';
      document.getElementById('logo-div').className = 'footer-logo-div';
      document.getElementById('sosial-div').className = 'sosyal-medya-div';
      document.getElementById('site-footer').className = 'site-footer-top';
    }
  }

  constructor(public router: Router,
              public authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.isCodeFlow = false;
    this.code = null;
    this.getScreenSize();
  }

  public _toggleCodeFlow() {
    this.isCodeFlow = !this.isCodeFlow;
  }

  public _goToAuction() {
    this.router.navigate(['/ihaledeki-arac-detay'], { queryParams: { izleyiciKodu: this.code } });
  }

}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/footer/footer.component.ts